module.exports = __webpack_public_path__ + "img/brand--quimica-suiza.b5f05207.png";